"use client";

import { Button } from "./ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "./ui/tooltip";
import { LinkIcon } from "lucide-react";
import Link from "next/link";
import { cn } from "@workspace/ui/lib/utils";

// buttonVariants base의 whitespace-nowrap 때문에 긴 text가 줄바꿈되지 않고 뷰포트를 넘겨
// 모바일 가로 스크롤이 생긴다(JCG-3619). ButtonClassName의 기본값만 고치면 오버라이드하는
// 호출부에서 조용히 사라지므로(RedAlert·textContentUtils·mdx-components가 그랬다),
// 기본값을 앞에 두고 호출부 값을 뒤에 병합한다. cn은 twMerge라 호출부가 실제로 지정한
// 유틸리티만 이기고, 지정하지 않은 기본값은 남는다.
// break-words는 공백 없는 긴 영문·URL까지 끊어준다. ui-patterns의 표 wrap 패턴
// (mdx-components의 th/td mapper, JCG-1925)과 같은 조합을 유지한다.
const DEFAULT_BUTTON_CLASS =
  "p-0 h-auto items-start whitespace-normal break-words";

interface TooltipLinkProps {
  href: string;
  text: string;
  target?: string;
  IconClassName?: string;
  TextClassName?: string;
  LinkClassName?: string;
  ButtonClassName?: string;
}

const TooltipLink = ({
  href,
  text,
  target,
  ButtonClassName,
  // items-center를 두지 않는다. LinkClassName은 Slot이 문자열을 이어붙이기만 해서
  // twMerge를 타지 않아, ButtonClassName의 정렬과 둘 다 남고 CSS 규칙 순서로 갈린다.
  LinkClassName = "inline-flex gap-x-2",
  // mt-1은 text-lg(line-height 28px)와 size-5(20px)의 4px 차이를 보정해, 한 줄일 때
  // items-center와 같은 위치를 만든다. 아이콘·글자 크기를 바꾸면 함께 조정한다.
  IconClassName = "size-5 mt-1",
  TextClassName = "text-lg",
}: TooltipLinkProps) => {
  // 외부 링크인지 확인
  const isExternalLink = href.startsWith("http") || href.startsWith("//");

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="link"
          asChild
          className={cn(DEFAULT_BUTTON_CLASS, ButtonClassName)}
        >
          {isExternalLink ? (
            <a
              href={href}
              className={LinkClassName}
              target={target || "_blank"}
              rel="noopener noreferrer"
            >
              <LinkIcon className={IconClassName} />
              <span className={TextClassName}>{text}</span>
            </a>
          ) : (
            <Link href={href} className={LinkClassName} target={target || "_blank"}>
              <LinkIcon className={IconClassName} />
              <span className={TextClassName}>{text}</span>
            </Link>
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>{isExternalLink ? "외부 링크로 이동" : "관련 포스팅으로 이동"}</p>
      </TooltipContent>
    </Tooltip>
  );
};

export default TooltipLink;
